var $6f80afde0270dda7$exports = {};
$6f80afde0270dda7$exports = {
    "alpha": `Alfa`,
    "blue": `Bl\xe5tt`,
    "brightness": `Ljusstyrka`,
    "green": `Gr\xf6nt`,
    "hue": `Nyans`,
    "lightness": `Ljushet`,
    "red": `R\xf6tt`,
    "saturation": `M\xe4ttnad`
};


export {$6f80afde0270dda7$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
